import WithCoApplicant from './WithCoApplicant';
import WithoutCoApplicant from './WithoutCoApplicant';
import useGetCoApplicant from '../../../hooks/selectors/useGetCoApplicant';

function CoApplicant() {
  const coApplicant = useGetCoApplicant();

  return <>{coApplicant ? <WithCoApplicant /> : <WithoutCoApplicant />}</>;
}

export default CoApplicant;
